import { render, staticRenderFns } from "./Funk.vue?vue&type=template&id=d7e9d93a&scoped=true&lang=pug&"
import script from "./Funk.vue?vue&type=script&lang=js&"
export * from "./Funk.vue?vue&type=script&lang=js&"
import style0 from "./Funk.vue?vue&type=style&index=0&id=d7e9d93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e9d93a",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
